/** Entry point of the phase E xinyi package (Taipei map: station, Memorial Hall, 101, Xinyi, Four Four South Village, Elephant Mountain; plus the MRT station). Imported once from main.ts. */
import '../render/propsXinyi';
import './xinyi';
import { registerNpcs } from '../world/npcs';
import { NPCS_XINYI } from '../world/npcsXinyi';

registerNpcs(NPCS_XINYI);
